import BaseCollection from "@/collections/BaseCollection";

export default class ResultsServiceCollection extends BaseCollection {
  constructor() {
    super();
  }

  // Route configuration
  routes() {
    const model = new (this.model())();
    
    return {
      fetch: `${
        process.env.VUE_APP_RESULTS_REPOSITORY_URL
      }/api/v1/${model.modelName()}`
    };
  }
}
